var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrowser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.229,
    height: 13.043,
    viewBox: "0 0 14.229 13.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "browser",
    d: "M11.265,1h-8.3A2.968,2.968,0,0,0,0,3.964v7.115a2.968,2.968,0,0,0,2.964,2.964h8.3a2.968,2.968,0,0,0,2.964-2.964V3.964A2.968,2.968,0,0,0,11.265,1Zm-8.3,1.186h8.3a1.779,1.779,0,0,1,1.779,1.779v.593H1.186V3.964A1.779,1.779,0,0,1,2.964,2.186Zm8.3,10.672h-8.3a1.779,1.779,0,0,1-1.779-1.779V5.743H13.043v5.336A1.779,1.779,0,0,1,11.265,12.858Zm0-4.743a.593.593,0,0,1-.593.593H3.557a.593.593,0,0,1,0-1.186h7.115A.593.593,0,0,1,11.265,8.115ZM8.893,10.486a.593.593,0,0,1-.593.593H3.557a.593.593,0,1,1,0-1.186H8.3A.593.593,0,0,1,8.893,10.486ZM1.779,3.372a.593.593,0,1,1,.593.593A.593.593,0,0,1,1.779,3.372Zm1.779,0a.593.593,0,1,1,.593.593A.593.593,0,0,1,3.557,3.372Zm1.779,0a.593.593,0,1,1,.593.593A.593.593,0,0,1,5.336,3.372Z",
    transform: "translate(0 -1)",
    fill: "#ff643a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.8d6b5d8d6d064dc68e8b82fa40af6d7c.svg";
export { ForwardRef as ReactComponent };